import { render } from "./app-button-dropdown-item.vue?vue&type=template&id=85ef4e04"
import script from "./app-button-dropdown-item.vue?vue&type=script&lang=js"
export * from "./app-button-dropdown-item.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/button/app-button-dropdown-item.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "85ef4e04"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('85ef4e04', __exports__)) {
    console.log('reload')
    api.reload('85ef4e04', __exports__)
  }
  
  module.hot.accept("./app-button-dropdown-item.vue?vue&type=template&id=85ef4e04", () => {
    console.log('re-render')
    api.rerender('85ef4e04', render)
  })

}


export default __exports__